// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetThemeResponse

import { WidgetButtonStyle } from './enums.gen';
import { hydrateWidgetThemeDark, type WidgetThemeDark, type WidgetThemeDarkApiResponse } from './widgetThemeDark.gen';

export type WidgetThemeApiResponse = {
	fontFamily: string | null;
	buttonStyle: WidgetButtonStyle;
	showLogo: boolean;
	showBusinessName: boolean;
	inversedHeaderTextColor: boolean;
	banner: string | null;
	backgroundImage: string | null;
	pageBackgroundColor: string | null;
	primary: string;
	background: string;
	useDarkMode: boolean;
	logo: string | null;
	dark: WidgetThemeDarkApiResponse;
};

export type WidgetTheme = {
	fontFamily: string | null;
	buttonStyle: WidgetButtonStyle;
	showLogo: boolean;
	showBusinessName: boolean;
	inversedHeaderTextColor: boolean;
	banner: string | null;
	backgroundImage: string | null;
	pageBackgroundColor: string | null;
	primary: string;
	background: string;
	useDarkMode: boolean;
	logo: string | null;
	dark: WidgetThemeDark;
};

export function hydrateWidgetTheme(data: WidgetThemeApiResponse): WidgetTheme {
	return {
		...data,
		dark: hydrateWidgetThemeDark(data.dark),
	};
}